import Icon from "../assets/Logos/Arcsmen_Logo.svg"


export default function Logo({ sx }) {
  return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <img src={Icon} width={200}/>
      </div>
  );
}
